import { getAppToken } from "../lib/api";

// Optional: route Telegram WS through the Worker relay for region-blocked users.
// Must be installed BEFORE the GramJS client connects.
let installed = false;

export function installWsProxy(): void {
  if (installed) return;
  installed = true;
  const Native = window.WebSocket;
  const proxyBase = `${location.origin}/api/ws`;
  const token = getAppToken();

  class ProxiedWebSocket extends Native {
    constructor(url: string | URL, protocols?: string | string[]) {
      const target = typeof url === "string" ? url : url.toString();
      // Only rewrite Telegram DC WS endpoints; pass everything else through.
      if (/\.web\.telegram\.org/.test(target)) {
        const proxied = `${proxyBase.replace(/^http/, "ws")}?token=${encodeURIComponent(
          token,
        )}&target=${encodeURIComponent(target)}`;
        super(proxied, protocols);
      } else {
        super(url, protocols);
      }
    }
  }
  // overriding the global constructor on purpose
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).WebSocket = ProxiedWebSocket;
}
